<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-main>
            <div class="main" style="width: 100%;;height: 1000px;overflow-y: hidden;;background: #e8e8e8;;display: flex;flex-direction: column;width: 100%;padding: 20px;">
                <div class="top" style="width: 100%;height: 50%;display: flex;flex-direction: row;">
                  <div class="video1" style="width: 70%; display: flex; align-items: center; justify-content: center;">
                    <div v-if="!videoSrc" class="upload-container">
                      <button @click="showUploadModal = true" style="border: none;border-radius:5px;cursor: pointer;;font-size: 20px;font-weight: 600;width: 200px;height: 50px;background: #1f63ff;color: #e8e8e8;">上传视频</button>
                      <input type="file" ref="videoFileInput" @change="handleVideoUpload" style="display: none;">
                    </div>
                    <video v-if="videoSrc" controls style="height: auto; width: 90%; height: 90%;">
                      <source :src="videoSrc" type="video/mp4">
                      您的浏览器不支持视频标签。
                    </video>
                  </div>
                    <div class="right-analyse" style="width: 30%;display: flex;flex-direction: column;">
                      <div class="corr-analyse" style="background: #fff;height: 50%;margin: 10px;">
                        <p style="font-size: 20px;font-weight: 600;margin: 0;margin-left: 10px;margin-top: 5px;">教学相关性分析</p>
                        <div style="height: 90%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                          <button
                            v-if="!isChartRendered"
                            style="border: none;border-radius:10px;cursor: pointer;;font-size: 20px;font-weight: 600;width: 200px;height: 50px;background: #1f63ff;color: #e8e8e8;"
                            @click="renderChart"
                          >
                            开始分析
                          </button>
                          <Correlation
                            v-if="isChartRendered"
                            :values="chartValues"
                          />
                        </div>
                      </div>
                        <div class="watch-count" style="background: #fff;height: 50%;margin: 10px;">
                            <p style="font-size: 20px;font-weight: 600;margin: 0;margin-left: 10px;margin-top: 5px;">学生观看次数</p>
                            <p style="font-size: 28px;font-weight: 700;margin: 3px;margin-left: 10px;">2,942</p>
                        </div>
                    </div>
                </div>
                <div class="second" style="width: 100%;height: 30%;background: #fff;margin: 10px;">
                  <p style="font-size: 20px;font-weight: 600;margin: 0;margin-left: 10px;margin-top: 5px;">内容时段划分</p>
                  <div style="height: 300px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <button
                      v-if="!isVideoInfoVisible"
                      style="border: none;border-radius:10px;cursor: pointer;font-size: 20px;font-weight: 600;width: 200px;height: 50px;background: #1f63ff;color: #e8e8e8;"
                      @click="toggleVideoInfo"
                    >
                      开始分析
                    </button>
                    <VideoInfo v-if="isVideoInfoVisible" />
                  </div>
                </div>
                <!-- <div class="bottom" style="width: 100%;height:auto ;background: #fff;margin: 10px;">
                  <p style="font-size: 20px;font-weight: 600;margin: 0;margin-left: 10px;margin-top: 5px;">思维导图及笔记生成</p>
                  <div style="height: 200px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <button style="border: none;border-radius:10px;cursor: pointer;;font-size: 20px;font-weight: 600;width: 200px;height: 50px;background: #1f63ff;color: #e8e8e8;">开始生成</button>
                  </div>
                </div> -->
            </div>
            <!-- 弹窗开始 -->
            <div v-if="showUploadModal" class="modal">
              <div class="modal-content">
                <span class="close" @click="showUploadModal = false">&times;</span>
                <h2 style="text-align: center;">添加教学视频</h2>
                <label for="upvideo">上传视频文件:</label>
                <p></p>
                <input type="file" @change="handleVideoUpload" />
                <p></p>
                <label for="videoName">视频标题:</label>
                <input type="text" v-model="videoName" id="videoName" placeholder="输入视频名称" />
                <label for="videoDescription">视频描述:</label>
                <input  type="text" v-model="videoDescription" id="videoDescription" placeholder="输入视频简介" style="height: 50px;" />
                <!-- <textarea v-model="videoDescription" id="videoDescription" placeholder="输入视频简介"></textarea> -->
                <button @click="submitVideoInfo" class="submit-button">提交</button>
              </div>
            </div>
            <!-- 弹窗结束 -->
        </el-main>
      </el-container>
      
    </div>
  </template>
  
  <script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';
import Correlation from '../components/Correlation.vue';
import VideoInfo from '../components/VideoInfo.vue';
export default {
  name: 'HomePage',
  components: { SideBar, TopBar,Correlation,VideoInfo},
  data() {
    return {
      videoSrc: null, // 用于存储视频的URL
      showUploadModal: false, // 控制弹窗显示
      videoName: '', // 视频名称
      videoDescription: '', // 视频简介
      isChartRendered: false,
      isVideoInfoVisible: false,
      chartValues: [1, 2, 3, 4,5] // 动态数据
    };
  },
  methods: {
    renderChart() {
      this.isChartRendered = true;
    },
    toggleVideoInfo() {
      this.isVideoInfoVisible = true;
    },
    handleVideoUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.'); // 去掉文件后缀
        this.videoName = fileNameWithoutExtension; // 设置视频标题为去掉后缀的文件名
        const reader = new FileReader();
        reader.onload = (e) => {
          this.videoSrc = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    submitVideoInfo() {
      // 这里可以添加提交视频信息的逻辑
      console.log('视频名称:', this.videoName);
      console.log('视频简介:', this.videoDescription);
      // 假设提交成功后，关闭弹窗
      this.showUploadModal = false;
    }
  }
};

  </script>
  
  <style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  float: right;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

input[type="text"],
textarea {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}

textarea {
  resize: vertical;
}

.submit-button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  float:right;
}

.submit-button:hover {
  background-color: #45a049;
}

.upload-container {
  text-align: center;
}
  </style>
  